export default __webpack_public_path__ + "static/media/gradiensProgram.117fa56d.png";